/**
 * nucleus-monitoring-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RemoteLogScheduleExecution { 
    id?: number;
    scheduleId?: number;
    serviceName?: string;
    instanceId?: string;
    action?: RemoteLogScheduleExecution.ActionEnum;
    startedAt?: string;
    endedAt?: string;
    logCount?: number;
    notes?: string;
}
export namespace RemoteLogScheduleExecution {
    export const ActionEnum = {
        Activated: 'ACTIVATED',
        Deactivated: 'DEACTIVATED',
        Skipped: 'SKIPPED'
    } as const;
    export type ActionEnum = typeof ActionEnum[keyof typeof ActionEnum];
}


